module.exports = __webpack_public_path__ + "img/9788952748669.5fb6ba48.jpg";